import { Reservation, ReservationStatus } from 'modules/arena/reservations/types';

export const RESERVATION_STATUS_META: Record<
  ReservationStatus,
  { label: string; tone: 'success' | 'warning' | 'danger' | 'neutral' | 'accent' }
> = {
  pending: { label: 'Pendente', tone: 'neutral' },
  awaiting_payment: { label: 'Aguardando pagamento', tone: 'warning' },
  confirmed: { label: 'Confirmada', tone: 'success' },
  cancelled: { label: 'Cancelada', tone: 'danger' },
  expired: { label: 'Expirada', tone: 'neutral' },
  completed: { label: 'Concluída', tone: 'accent' },
  no_show: { label: 'No-show', tone: 'warning' },
};

export const RESERVATION_STATUS_FILTERS: { value: ReservationStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'Todas' },
  { value: 'pending', label: 'Pendentes' },
  { value: 'awaiting_payment', label: 'Aguardando pagamento' },
  { value: 'confirmed', label: 'Confirmadas' },
  { value: 'completed', label: 'Concluídas' },
  { value: 'cancelled', label: 'Canceladas' },
  { value: 'expired', label: 'Expiradas' },
  { value: 'no_show', label: 'No-show' },
];

// Usados no formulário de "nova reserva em nome de cliente" (seção 4: recepção).
export const MANUAL_RESERVATION_COURTS = [
  'Areia 1 · descoberta',
  'Areia 2 · descoberta',
  'Areia 3 · coberta',
  'Quadra 5 · pickleball',
];

export const MANUAL_RESERVATION_SPORTS = ['Beach Tennis', 'Futevôlei', 'Pickleball', 'Vôlei de Praia'];

export const MANUAL_RESERVATION_PAYMENT_METHODS = ['Pix', 'Cartão', 'Dinheiro'];

export const DEFAULT_CANCELLATION_POLICY = 'Reembolso integral até 24h antes';

export const MOCK_RESERVATIONS: Reservation[] = [
  {
    id: '#10428',
    courtName: 'Areia 3 · coberta',
    sport: 'Beach Tennis',
    dateLabel: 'hoje, 12 set',
    timeLabel: '18:00–19:00',
    durationLabel: '1h',
    responsiblePlayer: 'Rafael Nunes',
    totalAmount: 83.2,
    platformFeeSnapshot: 1.66,
    cancellationPolicySnapshot: 'Reembolso integral até 24h antes',
    status: 'awaiting_payment',
    expiresAtLabel: '19:42',
    createdAtLabel: 'hoje 18:02',
    participants: [
      { name: 'Rafael Nunes', amountDue: 20.8, amountPaid: 20.8, method: 'Pix' },
      { name: 'Júlia M.', amountDue: 20.8, amountPaid: 20.8, method: 'Cartão' },
      { name: 'Diego C.', amountDue: 20.8, amountPaid: 0, method: 'Pix' },
      { name: 'Vaga 4', amountDue: 20.8, amountPaid: 0, method: '—' },
    ],
  },
  {
    id: '#10427',
    courtName: 'Areia 1 · descoberta',
    sport: 'Beach Tennis',
    dateLabel: 'hoje, 12 set',
    timeLabel: '17:00–18:00',
    durationLabel: '1h',
    responsiblePlayer: 'Marina L.',
    totalAmount: 60,
    platformFeeSnapshot: 1.2,
    cancellationPolicySnapshot: 'Reembolso integral até 24h antes',
    status: 'pending',
    expiresAtLabel: '17:15',
    createdAtLabel: 'hoje 17:00',
    participants: [{ name: 'Marina L.', amountDue: 60, amountPaid: 0, method: '—' }],
  },
  {
    id: '#10420',
    courtName: 'Areia 2 · descoberta',
    sport: 'Futevôlei',
    dateLabel: 'hoje, 12 set',
    timeLabel: '19:00–20:00',
    durationLabel: '1h',
    responsiblePlayer: 'Léo S.',
    totalAmount: 60,
    platformFeeSnapshot: 1.2,
    cancellationPolicySnapshot: 'Reembolso integral até 24h antes',
    status: 'confirmed',
    createdAtLabel: 'ontem 14:20',
    participants: [{ name: 'Léo S.', amountDue: 60, amountPaid: 60, method: 'Pix' }],
  },
  {
    id: '#10415',
    courtName: 'Quadra 5 · pickleball',
    sport: 'Pickleball',
    dateLabel: 'hoje, 12 set',
    timeLabel: '16:00–17:00',
    durationLabel: '1h',
    responsiblePlayer: 'Bia R.',
    totalAmount: 55,
    platformFeeSnapshot: 1.1,
    cancellationPolicySnapshot: 'Reembolso integral até 24h antes',
    status: 'completed',
    createdAtLabel: '10 set 09:12',
    participants: [{ name: 'Bia R.', amountDue: 55, amountPaid: 55, method: 'Cartão' }],
  },
  {
    id: '#10408',
    courtName: 'Areia 3 · coberta',
    sport: 'Beach Tennis',
    dateLabel: 'ontem, 11 set',
    timeLabel: '20:00–21:00',
    durationLabel: '1h',
    responsiblePlayer: 'Ana P.',
    totalAmount: 80,
    platformFeeSnapshot: 1.6,
    cancellationPolicySnapshot: 'Reembolso integral até 24h antes',
    status: 'no_show',
    createdAtLabel: '9 set 11:30',
    participants: [{ name: 'Ana P.', amountDue: 80, amountPaid: 80, method: 'Pix' }],
  },
  {
    id: '#10391',
    courtName: 'Quadra 5 · pickleball',
    sport: 'Pickleball',
    dateLabel: '10 set',
    timeLabel: '16:00–17:00',
    durationLabel: '1h',
    responsiblePlayer: 'Diego C.',
    totalAmount: 41.6,
    platformFeeSnapshot: 0.83,
    cancellationPolicySnapshot: 'Reembolso integral até 24h antes',
    status: 'expired',
    createdAtLabel: '10 set 15:40',
    participants: [{ name: 'Diego C.', amountDue: 41.6, amountPaid: 0, method: '—' }],
  },
  {
    id: '#10355',
    courtName: 'Areia 1 · descoberta',
    sport: 'Beach Tennis',
    dateLabel: '8 set',
    timeLabel: '18:00–19:00',
    durationLabel: '1h',
    responsiblePlayer: 'Marina L.',
    totalAmount: 80,
    platformFeeSnapshot: 1.6,
    cancellationPolicySnapshot: 'Reembolso integral até 24h antes',
    status: 'cancelled',
    createdAtLabel: '5 set 10:00',
    participants: [{ name: 'Marina L.', amountDue: 80, amountPaid: 80, method: 'Pix' }],
  },
  {
    id: '#10350',
    courtName: 'Areia 2 · descoberta',
    sport: 'Vôlei de Praia',
    dateLabel: '7 set',
    timeLabel: '17:00–18:00',
    durationLabel: '1h',
    responsiblePlayer: 'Carla M.',
    totalAmount: 60,
    platformFeeSnapshot: 1.2,
    cancellationPolicySnapshot: 'Reembolso integral até 24h antes',
    status: 'completed',
    createdAtLabel: '3 set 08:20',
    participants: [{ name: 'Carla M.', amountDue: 60, amountPaid: 60, method: 'Cartão' }],
  },
];
